import React, { useState } from 'react';
import { Input, Popconfirm } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

interface IProps {
  value: string;
  onChange: (val: string) => void;
  getPopContainer: () => HTMLElement;
}

const Index: React.FC<IProps> = (props) => {
  const { onChange, getPopContainer, value } = props;
  const [inputValue, setInputValue] = useState(value);

  const handleVisibleChange: (visible) => void = (visible) => {
    if (visible) {
      setInputValue(value);
    }
  };

  const handleRemarkChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    const val = event.target.value || '';
    setInputValue(val);
  };

  return (
    <Popconfirm
      title={
        <Input.TextArea
          placeholder={intl.get('reservation_field_input_default_placeholder')}
          className={styles.remarkInput}
          value={inputValue}
          onChange={handleRemarkChange}
          autoFocus
          maxLength={10000}
          rows={3}
          autoSize
          showCount
        />
      }
      icon=""
      placement="bottom"
      onOpenChange={handleVisibleChange}
      getPopupContainer={getPopContainer}
      overlayClassName={styles.remarkInputContainer}
      onConfirm={() => onChange(inputValue)}
    >
      <EditOutlined />
    </Popconfirm>
  );
};

export default Index;
